// Images below the fold shall not be loaded immediately but only after the page has finished loading
// Also load the correct image variant if set to avoid unnecessary heavy images

import '@/assets/javascripts/on/utility-constant/debouncer'
import { onDOMContentLoaded, onLoad } from '@/helpers/event'
;(function () {
  var deferredImages,
    deferredBackgroundImages,
    normalBackgroundImages,
    imageVariant = 'huge',
    loaderIsInitialized = false,
    imageVariants = {
      smallest: 900,
      small: 1200,
      medium: 1600,
      large: 2048,
      huge: 2880,
    },
    imageSrcSetEvent = new CustomEvent('on:image-src-set'),
    normalBackgroundUrlReadyEvent = new CustomEvent('on:normal-background-url-ready'),
    deferredBackgroundUrlReadyEvent = new CustomEvent('on:deferred-background-url-ready'),
    resizeCallbackFunction = function () {
      imageVariant = determineImageVariant()
      setImageSrc(deferredImages, imageVariant)
      setBackgroundUrl(normalBackgroundImages, imageVariant, normalBackgroundUrlReadyEvent)
      setBackgroundUrl(deferredBackgroundImages, imageVariant, deferredBackgroundUrlReadyEvent)
    },
    determineImageVariant = function () {
      var vpWidth = window.innerWidth
      var pixelDensity = Math.min(window.devicePixelRatio, 2)
      var calcWidth = vpWidth * pixelDensity

      if (calcWidth <= imageVariants.smallest) {
        return 'smallest'
      } else if (calcWidth <= imageVariants.small) {
        return 'small'
      } else if (calcWidth <= imageVariants.medium) {
        return 'medium'
      } else if (calcWidth <= imageVariants.large) {
        return 'large'
      } else {
        return 'huge'
      }
    },
    setImageSrc = function (images) {
      for (var i = images.length; i--; ) {
        if (images[i].getAttribute('data-src')) {
          if (images[i].getAttribute('data-srcset')) {
            images[i].setAttribute('srcset', images[i].getAttribute('data-srcset'))
          }
          images[i].setAttribute('src', images[i].getAttribute('data-src'))
        }
      }
      document.dispatchEvent(imageSrcSetEvent)
    },
    setBackgroundUrl = function (backgroundImages, imageVariant, dispatchEvent) {
      for (var i = backgroundImages.length; i--; ) {
        if (backgroundImages[i].getAttribute('data-src-' + imageVariant)) {
          backgroundImages[i].style.backgroundImage =
            'url("' + backgroundImages[i].getAttribute('data-src-' + imageVariant) + '")'
        } else {
          backgroundImages[i].style.backgroundImage =
            'url("' + backgroundImages[i].getAttribute('data-src') + '")'
        }
      }
      document.dispatchEvent(dispatchEvent)
    },
    triggerDomContentLoadedFunctions = function () {
      setBackgroundUrl(normalBackgroundImages, imageVariant, normalBackgroundUrlReadyEvent)
    },
    triggerLoadedFunctions = function () {
      initLoader()
      setImageSrc(deferredImages, imageVariant)
      setBackgroundUrl(deferredBackgroundImages, imageVariant, deferredBackgroundUrlReadyEvent)
    },
    triggerResizeFunctions = function () {
      initLoader()
      On.Debouncer().debounce({
        callback: resizeCallbackFunction,
        debounceTime: 200,
      })
    },
    refreshSettings = function () {
      deferredImages = document.querySelectorAll('.js-deferred-image')
      deferredBackgroundImages = document.querySelectorAll('.js-deferred-background-image')
      normalBackgroundImages = document.querySelectorAll('.js-normal-background-image')
      imageVariant = determineImageVariant()
    },
    initLoader = function () {
      // In some environments it's possible that a resize event gets fired before DOMContentLoaded
      // we have to prevent that "triggerDomContentLoadedFunctions" gets called in this case
      if (!loaderIsInitialized && document.readyState !== 'loading') {
        refreshSettings()
        triggerDomContentLoadedFunctions()
        loaderIsInitialized = true
      }
    }

  onDOMContentLoaded().then(initLoader)
  onLoad().then(triggerLoadedFunctions)
  window.addEventListener('resize', triggerResizeFunctions)
})()
